import * as React from "react";
import { useCallback } from "react";
import { SwatchesPicker } from "react-color";
const ColorPicker = ({ onChange, height = 135 * 2 + 24 + 16, width = 50 * 5, ...rest }) => {
  const onColorChange = useCallback(
    (color, event) => {
      onChange(color.hex, event);
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(SwatchesPicker, { height, width, ...rest, onChange: onColorChange });
};
export default ColorPicker;
